/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Full_SetInputs */

const en_field_full_set = /** @type {(inputs: Field_Full_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Box & Papers?`)
};

const es_field_full_set = /** @type {(inputs: Field_Full_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Caja y papeles?`)
};

const fr_field_full_set = /** @type {(inputs: Field_Full_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boîte & Papiers ?`)
};

const de_field_full_set = /** @type {(inputs: Field_Full_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Box & Papiere?`)
};

const ja_field_full_set = /** @type {(inputs: Field_Full_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`箱と保証書は揃っているか`)
};

const zh_field_full_set = /** @type {(inputs: Field_Full_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`包装盒和保卡全套？`)
};

const ar_field_full_set = /** @type {(inputs: Field_Full_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هل يشمل العلبة والأوراق؟`)
};

const id_field_full_set = /** @type {(inputs: Field_Full_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kotak & Surat?`)
};

const it_field_full_set = /** @type {(inputs: Field_Full_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scatola & Garanzia?`)
};

const ru_field_full_set = /** @type {(inputs: Field_Full_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Коробка и документы?`)
};

const pt_field_full_set = /** @type {(inputs: Field_Full_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caixa e Documentos?`)
};

const ko_field_full_set = /** @type {(inputs: Field_Full_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`풀세트(상자 및 보증서) 여부`)
};

/**
* | output |
* | --- |
* | "Box & Papers?" |
*
* @param {Field_Full_SetInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_full_set = /** @type {((inputs?: Field_Full_SetInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Full_SetInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_full_set(inputs)
	if (locale === "es") return es_field_full_set(inputs)
	if (locale === "fr") return fr_field_full_set(inputs)
	if (locale === "de") return de_field_full_set(inputs)
	if (locale === "ja") return ja_field_full_set(inputs)
	if (locale === "zh") return zh_field_full_set(inputs)
	if (locale === "ar") return ar_field_full_set(inputs)
	if (locale === "id") return id_field_full_set(inputs)
	if (locale === "it") return it_field_full_set(inputs)
	if (locale === "ru") return ru_field_full_set(inputs)
	if (locale === "pt") return pt_field_full_set(inputs)
	return ko_field_full_set(inputs)
});